/* AJK SOUQ – auto + manual horizontal rails (reviews etc.)
   Markup: <div class="ajk-rail" data-ajk-rail data-speed="45"> <div class="ajk-rail__track"> cards… </div> (optional prev/next buttons) </div>
   - khud continuous scroll hota hai (infinite loop)
   - finger/mouse drag, trackpad, arrows se manually scroll ho sakta hai; hover/touch par ruk jata hai, phir khud chal parta hai */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function Rail(root) {
    var track = root.querySelector('.ajk-rail__track');
    if (!track || root.__ajkRail) return;
    root.__ajkRail = true;

    var speed = parseFloat(root.getAttribute('data-speed')) || 45; // px per second
    var touchOnly = window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;
    var auto = root.getAttribute('data-auto') !== 'false' && !reduce && !touchOnly; /* touch devices: native swipe only = smooth */
    var originals = [].slice.call(track.children);
    if (!originals.length) return;

    var L = 0, copies = 1, ready = false;
    var paused = false, hoverPause = false, userUntil = 0, visible = true, raf = 0, last = 0, pos = 0;

    function build() {
      // remove old clones
      [].slice.call(track.querySelectorAll('[data-ajk-clone]')).forEach(function (n) { n.remove(); });
      var first = originals[0];
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      var sum = 0;
      originals.forEach(function (c) { sum += c.getBoundingClientRect().width; });
      L = sum + gap * originals.length;
      if (!L || !track.clientWidth) return false;
      copies = Math.ceil(track.clientWidth / L) + 2;
      for (var k = 1; k < copies; k++) {
        originals.forEach(function (c) {
          var n = c.cloneNode(true);
          n.setAttribute('data-ajk-clone', '1'); n.classList.remove('alm-pre'); n.classList.add('alm-in');
          n.setAttribute('aria-hidden', 'true');
          [].forEach.call(n.querySelectorAll('a,button,input,[tabindex]'), function (x) { x.setAttribute('tabindex', '-1'); });
          track.appendChild(n);
        });
      }
      track.scrollLeft = pos = L; // start in the first clone set so both directions work
      return true;
    }

    function wrap() {
      var s = track.scrollLeft;
      if (s >= 2 * L) { track.scrollLeft = s - L; }
      else if (s < L) { track.scrollLeft = s + L; }
      pos = track.scrollLeft;
    }

    function holdUser(ms) { userUntil = Date.now() + (ms || 2500); }

    function tick(t) {
      raf = requestAnimationFrame(tick);
      var dt = Math.min(64, t - (last || t)); last = t;
      if (!ready || !auto || paused || hoverPause || !visible || document.hidden) return;
      if (Date.now() < userUntil) { pos = track.scrollLeft; return; }
      pos += speed * dt / 1000;
      if (pos >= 2 * L) pos -= L;
      track.scrollLeft = pos;
    }

    // ---- manual interaction
    track.addEventListener('scroll', function () {
      if (!ready) return;
      if (Date.now() < userUntil || paused) { wrap(); }
    }, { passive: true });
    ['touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      track.addEventListener(ev, function () { holdUser(3000); }, { passive: true });
    });
    track.addEventListener('touchend', function () { holdUser(2500); }, { passive: true });
    root.addEventListener('mouseenter', function () { hoverPause = true; });
    root.addEventListener('mouseleave', function () { hoverPause = false; holdUser(900); });
    root.addEventListener('focusin', function () { hoverPause = true; });
    root.addEventListener('focusout', function () { hoverPause = false; });

    // mouse drag
    var drag = null;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, s: track.scrollLeft };
      track.classList.add('is-drag'); holdUser(3000);
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      track.scrollLeft = drag.s - (e.clientX - drag.x); holdUser(3000);
    });
    window.addEventListener('pointerup', function () {
      if (!drag) return; drag = null; track.classList.remove('is-drag'); holdUser(2500);
    });

    // arrows
    var prev = root.querySelector('.ajk-rail__btn--prev'), next = root.querySelector('.ajk-rail__btn--next');
    function step() { var c = track.children[0]; return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 12) : 280; }
    function go(dir) {
      holdUser(3500);
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.05 }).observe(root);
    }

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { var off = pos - L; ready = false; if (build()) { track.scrollLeft = pos = L + (off % L + L) % L; ready = true; } }, 250);
    });

    function start() {
      if (build()) { ready = true; if (!raf) raf = requestAnimationFrame(tick); }
      else setTimeout(start, 250);
    }
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
    // images may change widths after load
    setTimeout(function () { if (ready) { var off = pos - L; ready = false; if (build()) { track.scrollLeft = pos = L + (off % L + L) % L; ready = true; } } }, 1500);
  }

  function init() { [].forEach.call(document.querySelectorAll('[data-ajk-rail]'), Rail); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
